import React, { ReactNode } from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import SpecificationsSkeletonList from 'src/pages/Item/skeletons/SpecificationsSkeletonList';
import DocumentsSkeletonGrid from 'src/components/Documents/skeletons/DocumentsSkeletonGrid';

const ITEM_TAB_SKELETON_ROW_COUNT: number = 4;

// Generic fallback for tabs without a dedicated skeleton.
const ItemTabSkeleton = () => (
  <div style={{ padding: '1rem' }}>
    {Array.from({ length: ITEM_TAB_SKELETON_ROW_COUNT }, (_, index: number) => (
      <div key={`item-tab-skeleton-${index}`} style={{ marginBottom: '0.75rem' }}>
        <Skeleton variant="rect" width="100%" height="3rem" />
      </div>
    ))}
  </div>
);

// Dispatches to the skeleton matching the real tab body. Tabs without a
// tailored skeleton (FAQs, Service Requests) fall back to the generic block.
export const getItemTabSkeleton = (label: string): ReactNode => {
  if (label === 'Specifications') {
    return <SpecificationsSkeletonList />;
  }
  if (label === 'Manuals & Documents') {
    return <DocumentsSkeletonGrid />;
  }
  return <ItemTabSkeleton />;
};

export default ItemTabSkeleton;
